// Widget Registry
// Import all widgets here to register them

import StatsWidget from './StatsWidget';
import EntriesWidget from './EntriesWidget';
import TeamWidget from './TeamWidget';
import PipelineWidget from './PipelineWidget';
import WidgetWrapper from './WidgetWrapper';

export const widgetRegistry = {
  'stats': {
    component: StatsWidget,
    title: '📊 Overview',
    defaultSize: { cols: 12 },
    category: 'business'
  },
  'recent-entries': {
    component: EntriesWidget,
    title: 'Recent Time Entries',
    defaultSize: { cols: 6 },
    category: 'business'
  },
  'team': {
    component: TeamWidget,
    title: '👥 Team Activity',
    defaultSize: { cols: 6 },
    category: 'business'
  },
  'pipeline': {
    component: PipelineWidget,
    title: '📊 Sales Pipeline',
    defaultSize: { cols: 6 },
    category: 'business'
  }
};

export const getWidget = (id) => widgetRegistry[id];

export const getWidgetsByCategory = (cat) =>
  Object.entries(widgetRegistry).filter(([_, w]) => w.category === cat);

export { WidgetWrapper };
export default widgetRegistry;